(function () {
  function insertSectionCartDrawer() {
    if (document.querySelector('#CartDrawer .cart-drawer-items-wrapper')) return;

    const cartDrawerItems = document.querySelector('#CartDrawer cart-drawer-items');
    if (!cartDrawerItems || cartDrawerItems.classList.contains('is-empty')) return;

    const parent = cartDrawerItems.parentNode;
    if (!parent) return;

    const wrapper = document.createElement('div');
    wrapper.classList.add('cart-drawer-items-wrapper');
    parent.insertBefore(wrapper, cartDrawerItems);
    wrapper.appendChild(cartDrawerItems);

    const upsells = document.querySelector('#cart-drawer-upsell-wrapper');
    if (upsells) {
      wrapper.insertAdjacentHTML('beforeend', upsells.innerHTML);
    }

    if (!document.querySelector('.cart-drawer-upsell-list li')) {
      document.querySelector('#cart-drawer-upsell')?.remove();
    }
  }

  function insertSectionCartPage() {
    const cartItems = document.querySelector('cart-items');
    if (!cartItems) return;

    document.querySelector('#MainContent #cart-drawer-upsell')?.remove();

    const upsells = document.querySelector('#cart-drawer-upsell-wrapper');
    const pageWidth = cartItems.querySelector('.page-width');
    if (upsells && pageWidth) {
      pageWidth.insertAdjacentHTML('beforeend', upsells.innerHTML);
    }

    if (!document.querySelector('.cart-drawer-upsell-list li')) {
      document.querySelector('#cart-drawer-upsell')?.remove();
    }
  }

  async function refreshUpsellWrapper(contextLabel) {
    try {
      const response = await fetch(window.location.href, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      if (!response.ok) {
        throw new Error(`${contextLabel} HTTP error: ${response.status}`);
      }

      const text = await response.text();
      const newDocument = new DOMParser().parseFromString(text, 'text/html');
      const currentWrapper = document.querySelector('#cart-drawer-upsell-wrapper');
      const newWrapper = newDocument.querySelector('#cart-drawer-upsell-wrapper');

      if (currentWrapper && newWrapper) {
        currentWrapper.replaceWith(newWrapper);
      }
    } catch (error) {
      console.error('Cart upsell refresh error:', error);
    }
  }

  insertSectionCartDrawer();

  window.onChangeKsUpsellVariantSelector = function (select, event) {
    if (event) event.preventDefault();
    if (!select || !select.options || select.selectedIndex < 0) return;

    const selectedOption = select.options[select.selectedIndex];
    const imgSrc = selectedOption?.dataset?.variantImg;
    if (!imgSrc) return;

    const item = select.closest('.cart-drawer-upsell-list-item');
    const img = item?.querySelector?.('.cart-drawer-upsell-list-item-left img');
    if (img) img.src = imgSrc;
  };

  function listenCartDrawer() {
    const element = document.querySelector('cart-drawer');
    if (!element) return;

    let timer;

    const observer = new MutationObserver(() => {
      if (timer) clearTimeout(timer);

      timer = setTimeout(async () => {
        await refreshUpsellWrapper('cart drawer');
        insertSectionCartDrawer();
      }, 250);
    });

    observer.observe(element, {
      attributes: true,
      childList: true,
      subtree: true,
    });
  }

  function listenCartPage() {
    const element = document.querySelector('#MainContent .cart__items');
    if (!element) return;

    let timer;

    const observer = new MutationObserver(() => {
      if (timer) clearTimeout(timer);

      timer = setTimeout(async () => {
        await refreshUpsellWrapper('cart page');
        insertSectionCartPage();
      }, 250);
    });

    observer.observe(element, {
      attributes: true,
      childList: true,
      subtree: true,
    });
  }

  listenCartDrawer();
  listenCartPage();
})();
